import { Routes, Route } from "react-router-dom";

import HospitalityHome from "./page/hospitality/HospitalityHome";
import HospitalityProvider from "./page/hospitality/HospitalityProvider";
import HospitalityCategory from "./page/hospitality/HospitalityCategory";
import HospitalityLogin from "./page/auth/HospitalityLogin";
import HospitalityRegister from "./page/auth/HospitalityRegister";
import CityPartnerPage from "./page/cityPartner/CityPartnerPage";

import HospitalityHeader from "./components/HospitalityHeader";
import HospitalityFooter from "./components/HospitalityFooter";
import AdminPanel from "./page/AdminPanel";
import AboutPage from "./components/AboutPage";
import PrivacyPolicyPage from "./components/PrivacyPolicyPage";
import TermsOfServicePage from "./components/TermsOfServicePage";


export default function App() {
  return (
    <>
      <HospitalityHeader />
      <main>
        <Routes>
          <Route path="/" element={<HospitalityHome />} />
          <Route path="/category/:category" element={<HospitalityCategory />} />
          <Route path="/provider/:id" element={<HospitalityProvider />} />
          <Route path="/login" element={<HospitalityLogin />} />
          <Route path="/register" element={<HospitalityRegister />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/city-partner" element={<CityPartnerPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="*" element={<HospitalityHome />} />
        </Routes>
      </main>
      <HospitalityFooter />
    </>
  );
}
